import { getGlobalParams, getCustomIntl } from 'config/config'

import { nextByAddFav } from '../data/subjects/fundInfoItems'
import { isNonProd } from './check-env'
import { dispatchFundCompareEvent } from './tracking'

// Call function provided by Django to update breadcrumb
const updateBreadCrumb = (breadcrumbContent, needBgColor) => {
  setTimeout(() => {
    if (window.FundHelper) {
      if (breadcrumbContent && window.FundHelper.updateBreadCrumb) {
        window.FundHelper.updateBreadCrumb(breadcrumbContent, needBgColor)
      } else if (window.FundHelper.clearFundNameFromBreadCrumb) {
        window.FundHelper.clearFundNameFromBreadCrumb()
      }
    }
  }, 0)
}

const displaySoftCloseMsg = (flag) => {
  setTimeout(() => {
    if (window.FundHelper) {
      if (flag) {
        window.FundHelper.showSoftClosedBanner()
      } else {
        window.FundHelper.hideSoftClosedBanner()
      }
    }
  }, 0)
}

const updateHtmlTitle = (title) => {
  const intl = getCustomIntl()
  document.title = `${title}${intl.formatMessage({ id: 'titleSuffix' })}`
}

const updateHtmlTitleWithoutSuffix = (title) => {
  document.title = title
}

const updateMetaTag = (metadata) => {
  if (isNonProd()) {
    console.log(`[UPDATE META]: ${JSON.stringify(metadata)}`)
  }
  const head = document.getElementsByTagName('head')[0]
  if (head && Array.isArray(metadata) && metadata.length > 0) {
    const metaList = document.querySelectorAll('head meta')
    const fragment = document.createDocumentFragment()
    metaList.forEach((meta) => fragment.appendChild(meta))
    metadata.forEach((value) => {
      const node = fragment.querySelector(`meta[${value.attrName}="${value.attrContent}"]`)
      if (node) {
        node.setAttribute(value.attrName, value.attrContent)
        node.setAttribute('content', value.content)
      } else {
        const newMeta = document.createElement('meta')
        newMeta.setAttribute(value.attrName, value.attrContent)
        newMeta.setAttribute('content', value.content)
        fragment.appendChild(newMeta)
      }
    })
    const firstElem = head.firstElementChild
    if (firstElem) {
      head.insertBefore(fragment, firstElem)
    } else {
      head.appendChild(fragment)
    }
  }
}

const { favListName, fundComparisonCart, funds2CartJob } = getGlobalParams()

const handleFavItems = (favClassList, shareClassId) => {
  let favItems = localStorage.getItem(favListName) ? JSON.parse(localStorage.getItem(favListName)) : []
  if (favClassList.contains('added')) {
    favClassList.remove('added')
    favItems = favItems.filter((item) => item !== shareClassId)
  } else {
    favClassList.add('added')
    favItems.push(shareClassId)
  }

  nextByAddFav(favItems.length)
  localStorage.setItem(favListName, JSON.stringify(favItems))
}

const handleComparisonItems = (shareClassInfo) => {
  let comparisonItems = sessionStorage.getItem(fundComparisonCart) ? JSON.parse(sessionStorage.getItem(fundComparisonCart)) : []
  const isAddedToComparison = !!comparisonItems.find((item) => item.shareClassId === shareClassInfo.shareClassId)

  if (isAddedToComparison) {
    comparisonItems = comparisonItems.filter((item) => item.shareClassId !== shareClassInfo.shareClassId)
  } else {
    comparisonItems.push(shareClassInfo)
    dispatchFundCompareEvent(
      shareClassInfo.isFromDetailPage ? 'compare - compare this fund' : 'compare - add fund for comparison',
      shareClassInfo.shareClassId
    )
  }

  funds2CartJob.funds2CartTrigger(comparisonItems)
  sessionStorage.setItem(fundComparisonCart, JSON.stringify(comparisonItems))
}

export { updateBreadCrumb, displaySoftCloseMsg, updateHtmlTitle, updateHtmlTitleWithoutSuffix, updateMetaTag, handleFavItems, handleComparisonItems }
